module.exports = __webpack_public_path__ + "assets/20a14e927f7879cafae6a53d4d633427.png";